module.exports = __webpack_public_path__ + "static/media/human-cause.2b316629.jpeg";